export const thorondorHeaderItems = [
  {
    id: "information",
    name: "Informacion",
    routeName: "thorondor-information",
  },
  {
    id: "installation_guide",
    name: "Guia de instalacion",
    routeName: "thorondor-installation-guide",
  },
  {
    id: "agent_generator",
    name: "Generador de agentes",
    routeName: "thorondor-agent-generator",
  },
  {
    id: "dashboard",
    name: "Dashboard general",
    routeName: "thorondor-dashboard",
  },
  {
    id: "host_detail",
    name: "Detalle por host",
    routeName: "thorondor-host-detail",
  },
  {
    id: "monitorization_rules",
    name: "Reglas monitorizacion",
    routeName: "thorondor-monitorization-rules",
  },
  {
    id: "agents",
    name: "Agentes",
    routeName: "thorondor-agents",
  },
];
